import { Capacitor } from '@capacitor/core';

export const GOOGLE_WEB_CLIENT_ID =
  '317830624293-hjig7b1b9mo0ckpm7btvdprkph9r85oc.apps.googleusercontent.com';
export const GOOGLE_IOS_CLIENT_ID =
  '317830624293-viv4hiljdr2f6p87fkcinc67u8lnrsm7.apps.googleusercontent.com';

export function nativeSocialLoginConfig() {
  const config: {
    google: {
      webClientId: string;
      iOSClientId: string;
      iOSServerClientId: string;
      mode: 'online';
    };
    apple?: Record<string, never>;
  } = {
    google: {
      webClientId: GOOGLE_WEB_CLIENT_ID,
      iOSClientId: GOOGLE_IOS_CLIENT_ID,
      iOSServerClientId: GOOGLE_WEB_CLIENT_ID,
      mode: 'online',
    },
  };

  if (Capacitor.getPlatform() === 'ios') {
    config.apple = {};
  }

  return config;
}
